export const DEPLOYMENT_DOMAIN = process.env.DEPLOYMENT_DOMAIN;
export const ENABLE_IFSC_PAGES = process.env.ENABLE_IFSC_PAGES;
export const ENABLE_WEBINAR_PAGES = process.env.ENABLE_WEBINAR_PAGES;
export const API_AUTH_TOKEN = process.env.API_AUTH_TOKEN;
